import { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { C } from "../../constants/theme";
import { listaLojas, calcularPrecoLoja } from "../../constants/lojasOnline";
import { useTaxasLojas } from "../../hooks/useTaxasLojas";
import { toast } from "../../hooks/useToast";

// Resolvido só no clique: criar o callable no import faria este módulo
// exigir o Firebase inicializado só por ser importado (quebra teste de quem
// só renderiza a Calculadora, e atrasa o primeiro paint à toa).
const cfAtualizarTaxas = () => httpsCallable(getFunctions(undefined, "us-central1"), "taxasLojasAgora");

/* Botão + popup reaproveitado em Produtos e na Calculadora de preço: mostra
   quanto anunciar em cada loja online (Mercado Livre, Shopee, Amazon...) pra
   que, depois da comissão + taxa fixa (que variam por faixa de preço em
   cada uma), sobre o valor que o vendedor quer receber.

   `valor` é o LÍQUIDO desejado (custo + lucro), nunca o preço final da
   Calculadora — o preço final já vem com as taxas de venda descontadas, e
   passar ele aqui descontaria a comissão duas vezes.

   A tabela de taxas vem da fonte oficial de cada loja (useTaxasLojas); a
   tela sempre mostra de onde veio e quando foi conferida. */
export function BotaoCalcularLoja({ valor, style, compacto = false }) {
  const [aberto, setAberto] = useState(false);
  const [atualizando, setAtualizando] = useState(false);
  const tabela = useTaxasLojas();
  const lojas = listaLojas(tabela.lojas);

  const atualizarAgora = async () => {
    setAtualizando(true);
    try {
      await cfAtualizarTaxas()();
      toast("Taxas conferidas na fonte oficial.");
    } catch (e) {
      toast(e?.message || "Não deu pra conferir as taxas agora.", "error");
    } finally {
      setAtualizando(false);
    }
  };

  const dataCurta = (iso) => {
    if (!iso) return null;
    try { return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }); }
    catch { return null; }
  };

  return (
    <>
      {compacto ? <button type="button" className="calc-simulation-link" onClick={() => setAberto(true)}>Loja online</button> : (
<button onClick={() => setAberto(true)}
        style={{ display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", background:"none", border:"none", borderBottom:"1px solid rgba(255,255,255,0.06)", padding:"11px 2px", cursor:"pointer", textAlign:"left", ...style }}>
        <span style={{ fontSize:12.5, fontWeight:600, color:C.text, display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:13, opacity:.8 }}>🛒</span>Loja online
        </span>
        <span style={{ color:C.muted, fontSize:12 }}>›</span>
      </button>
)}

      {aberto && (
        <>
          <div onClick={() => setAberto(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1100 }} />
          <div role="dialog" aria-modal="true" aria-label="Preços em lojas online" onKeyDown={e=>{ if (e.key === "Escape") { e.stopPropagation(); setAberto(false); } }} style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(420px,94vw)", maxHeight:"85vh", overflowY:"auto", background:C.panel, border:"1px solid rgba(255,159,28,0.3)", borderRadius:18, padding:20, zIndex:1101, boxShadow:"0 24px 64px rgba(0,0,0,0.7)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
              <span style={{ color:"#ff9f1c", fontWeight:900, fontSize:14, letterSpacing:1 }}>🛒 PREÇO PRA LOJA ONLINE</span>
              <button autoFocus aria-label="Fechar preços de lojas" onClick={() => setAberto(false)} style={{ background:"none", border:"none", color:C.muted, fontSize:20, cursor:"pointer", lineHeight:1 }}>✕</button>
            </div>
            <div style={{ color:C.muted, fontSize:12, marginBottom:16 }}>
              Quanto você quer receber: <strong style={{ color:C.text }}>R$ {Number(valor || 0).toFixed(2)}</strong>
            </div>

            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {lojas.map(loja => {
                const { taxaTotal, precoAnunciar, liquido, faixa } = calcularPrecoLoja(valor || 0, loja);
                const extra = faixa?.tipoFixo === "pct"
                  ? (Number(faixa.valorFixo) > 0 ? ` + ${Number(faixa.valorFixo)}% do valor` : "")
                  : (Number(faixa?.valorFixo) > 0 ? ` + R$ ${Number(faixa.valorFixo).toFixed(2)}` : "");
                const sobra = liquido - Number(valor || 0);
                const fonte = loja.fonte || {};
                const agendado = loja.agendado;
                // Só avisa enquanto a data não chegou — depois dela o preço
                // acima já é o novo (faixasVigentes troca sozinho), e repetir
                // o aviso confundiria.
                const vigenciaFutura = agendado?.vigenciaEm && Date.parse(`${agendado.vigenciaEm}T00:00:00-03:00`) > Date.now();
                const precoFuturo = vigenciaFutura && agendado.faixas
                  ? calcularPrecoLoja(valor || 0, { faixas: agendado.faixas }).precoAnunciar
                  : null;
                return (
                  <div key={loja.id} style={{ background:"rgba(255,159,28,0.05)", border:"1px solid rgba(255,159,28,0.2)", borderRadius:10, padding:"10px 14px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
                      <span style={{ fontWeight:800, fontSize:13, color:C.text }}>{loja.nome || "Loja"}</span>
                      <span style={{ fontSize:10, color:C.muted }}>comissão {Number(faixa?.comissao) || 0}%{extra}</span>
                    </div>
                    <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:C.muted, marginBottom:2 }}>
                      <span>Taxa total da plataforma</span><span style={{ color:"#f59e0b" }}>−R$ {taxaTotal.toFixed(2)}</span>
                    </div>
                    <div style={{ display:"flex", justifyContent:"space-between", fontSize:15, fontWeight:900 }}>
                      <span style={{ color:C.text }}>Anunciar por</span><span style={{ color:"#ff9f1c" }}>R$ {precoAnunciar.toFixed(2)}</span>
                    </div>
                    {sobra > 0.01 && (
                      <div style={{ fontSize:10, color:C.muted, marginTop:4, lineHeight:1.5 }}>
                        Nesse preço você recebe <strong style={{ color:C.text }}>R$ {liquido.toFixed(2)}</strong> — a faixa de taxa dá um salto aqui, então não dá pra fechar no valor exato sem receber a menos.
                      </div>
                    )}
                    {precoFuturo != null && (
                      <div style={{ fontSize:10, color:"#f59e0b", marginTop:4 }}>
                        ⏳ A partir de {agendado.vigenciaEm.split("-").reverse().slice(0, 2).join("/")}: anunciar por R$ {precoFuturo.toFixed(2)}
                      </div>
                    )}
                    {fonte.status === "nao_configurada" && (
                      <div style={{ fontSize:10, color:C.muted, marginTop:4 }}>Tabela embutida — conecte um app do ML pra ela se atualizar sozinha.</div>
                    )}
                    {fonte.status === "sem_fonte" && (
                      <div style={{ fontSize:10, color:C.muted, marginTop:4 }}>Conferência manual — a Amazon não publica a tabela em formato legível.</div>
                    )}
                    {(fonte.status === "revisar" || fonte.status === "falhou") && (
                      <div style={{ fontSize:10, color:"#ef4444", marginTop:4, lineHeight:1.5 }}>
                        ⚠️ {fonte.status === "revisar" ? "A loja mudou a política e eu não consegui ler sozinho" : "Não consegui conferir a fonte"} — valendo a última tabela boa.
                        {fonte.url && <> <a href={fonte.url} target="_blank" rel="noreferrer" style={{ color:"#60a5fa" }}>Conferir na fonte</a></>}
                      </div>
                    )}
                  </div>
                );
              })}

              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, fontSize:10, color:C.muted, lineHeight:1.6, marginTop:2 }}>
                <span>
                  {tabela.origem === "oficial"
                    ? <>Taxas lidas da fonte oficial de cada loja{dataCurta(tabela.atualizadoEm) ? `, conferidas em ${dataCurta(tabela.atualizadoEm)}` : ""}. A comissão pode variar um pouco por categoria.</>
                    : <>Usando a tabela embutida no app — ainda não deu pra ler a fonte oficial. Confira no anúncio se tiver dúvida.</>}
                </span>
                <button type="button" onClick={atualizarAgora} disabled={atualizando}
                  style={{ flexShrink:0, background:"none", border:"1px solid rgba(255,159,28,0.35)", borderRadius:8, color:atualizando ? C.muted : "#ff9f1c", fontSize:10, fontWeight:700, padding:"5px 9px", cursor:atualizando ? "default" : "pointer" }}>
                  {atualizando ? "Conferindo…" : "Atualizar"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
